import { MtAccountUser, MtAccountUserGroup } from "server/models"
import { GET, DELETE, POST } from "client/store/utils"
import { AddAccountUserGroup } from "client/store"
import {
    AccountUserList,
    UserAccountList,
} from "./types"


export const LoadAllAccountUsers = () => (
    GET("/mtAccountUser/all")
    .then((rows: MtAccountUser[]) => {
        const accountUserList: AccountUserList = {}
        rows.forEach((row) => {
            const userIds: number[] = accountUserList[row.accountId] ? accountUserList[row.accountId].slice() : []
            userIds.push(row.userId)
            accountUserList[row.accountId] = userIds
        })
        return accountUserList
    })
)

export const LoadAllUserAccounts = () => (
    GET("/mtAccountUser/all")
    .then((rows: MtAccountUser[]) => {
        const userAccountList: UserAccountList = {}
        rows.forEach((row) => {
            const userIds: number[] = userAccountList[row.userId] ? userAccountList[row.userId].slice() : []
            userIds.push(row.accountId)
            userAccountList[row.userId] = userIds
        })
        return userAccountList
    })
)

export const LoadAccountUsers = (accountId: number) => (
    GET(`/mtAccountUser/accountUsers/${accountId}`)
    .then((rows: MtAccountUser[]) => {
        const userIds: number[] = []
        rows.forEach((row) => {
            userIds.push(row.userId)
        })
        return userIds
    })
)

export const LoadUserAccounts = (userId: number) => (
    GET(`/mtAccountUser/userAccounts/${userId}`)
    .then((rows: MtAccountUser[]) => {
        const accountIds: number[] = []
        rows.forEach((row) => {
            accountIds.push(row.accountId)
        })
        return accountIds
    })
)

export const AddAccountUser = (userIds: readonly number[], accountId: number, maxUsers: number) => {
    let newUsers: MtAccountUser[] = []
    const userGroups: MtAccountUserGroup[] = []

    // load actual user list before adding
    return LoadAccountUsers(accountId).then((assignedUserIds) => {
        userIds.forEach((userId) => {
            if (!assignedUserIds.includes(userId)) {
                newUsers.push({
                    userId,
                    accountId,
                })
            }
        })

        // limit number of users according to package settings
        // Super Admin has no limit for the number of users and has no groups
        if (maxUsers !== null && accountId !== 1) {
            const length = maxUsers - assignedUserIds.length
            newUsers = newUsers.slice(0, length > 0 ? length : 0)

            // create user groups
            newUsers.forEach((row, index) => {
                userGroups.push({
                    userId: row.userId,
                    accountId: row.accountId,
                    groupId: 2, // default "Users All" group
                })

                // first account user is Admin
                if (assignedUserIds.length === 0 && index === 0) {
                    userGroups.push({
                        userId: row.userId,
                        accountId: row.accountId,
                        groupId: 1, // default "Administrators" group
                    })
                }
            })
        }

        return POST(
            "/mtAccountUser/add",
            JSON.stringify(newUsers),
        ).then(() => AddAccountUserGroup(userGroups))
    })
}

export const DeleteAccountUser = (userId: number, accountId: number) => (
    DELETE(`/mtAccountUser/delete/${userId}/${accountId}`)
    .then((removedRows: number) => removedRows)
)
